import createModel, { prop } from 'models/lib/create_model';

export const OfferedQuestion = createModel({
  modelName: 'OfferedQuestion',

  properties: {
    id: prop(String).isRequired,
    text: prop(String).isRequired,
  },
});

export const ButtonQuestionResponse = createModel({
  modelName: 'ButtonQuestionResponse',

  properties: {
    offeredQuestions: prop([OfferedQuestion]).isRequired,
    questionsSource: prop(String).isRequired,
    selectedQuestionId: prop(String).isRequired,
    launcherId: prop(String).isRequired,
    pageUrl: prop(String).isRequired,
  },
});
